import { c as _c } from "react/compiler-runtime";
import { ArrowTurnDownLeftIcon } from '@systemeio/ui/icons';
import { ContactSlugEnum, DatePicker, FormInputSearch, FormSelect, Hint, PrimaryButton, Tooltip, getDate, toast } from '@systemeio/ui';
import { UnprocessableContentError } from '@systemeio/util';
import { ContactsLoco } from 'modules/contacts/constants/contacts-loco';
import { defaultFilters } from 'modules/contacts/contacts-bin/constants/constants';
import { ContactFilterRemovedReasonLocoKeys } from 'modules/contacts/contacts-bin/constants/contacts-bin-filter-titles';
import { useContactsBulkRestore } from 'modules/contacts/contacts-bin/hooks/use-contacts-bulk-restore';
import { useContactsRemovedList } from 'modules/contacts/contacts-bin/hooks/use-contacts-removed-list';
import { ContactFilterRemovedDataInterface, ContactRemovedInterface } from 'modules/contacts/contacts-bin/types/contact-removed-interface';
import { getBreadCrumbsData } from 'modules/contacts/contacts-bin/utils/get-bread-crumbs-data';
import { ContactFilterRemovedReasonTypeEnum, ContactSearchFieldEnum } from 'modules/contacts/enums/contact-enum';
import { useApplyFilterWithConditions } from 'modules/contacts/hooks/use-apply-filter-with-conditions';
import { useContactFilterPagination } from 'modules/contacts/hooks/use-contact-filter-pagination';
import { useFilterWithConditions } from 'modules/contacts/hooks/use-filter-with-conditions';
import { ContactFilterDateInterface, ContactFilterRemovedReasonInterface, ContactFilterTextInterface } from 'modules/contacts/types/contact-filter-interface';
import { ContactBulkInterface } from 'modules/contacts/types/contact-menu-interface';
import { NextPage } from 'next';
import React, { useEffect, useState } from 'react';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useListingSelect } from 'shared/hooks/use-listing-select';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getToday } from 'shared/utils/get-dates';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { OrderEnum } from 'shared/types/pagination-interface';
const Contacts: NextPage = () => {
  const $ = _c(171);
  const {
    user,
    isRootAdmin,
    intlLocale
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    contactsBulkRestore,
    isFetching
  } = useContactsBulkRestore();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      contactIds: [],
      conditions: [],
      type: "all-filtered-contacts"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [filterData, setFilterData] = useState(t0);
  const {
    setConditions,
    conditions,
    filter,
    setFilter,
    filterFields,
    filtersReady
  } = useFilterWithConditions(defaultFilters);
  let t1;
  if ($[1] !== conditions || $[2] !== setConditions) {
    t1 = {
      conditions,
      setConditions
    };
    $[1] = conditions;
    $[2] = setConditions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = useContactFilterPagination(t1);
  let t2;
  if ($[4] !== conditions || $[5] !== limit || $[6] !== pagination) {
    t2 = {
      limit,
      pagination,
      conditions
    };
    $[4] = conditions;
    $[5] = limit;
    $[6] = pagination;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    removedContacts,
    abort
  } = useContactsRemovedList(t2);
  let t3;
  if ($[8] !== setPagination) {
    t3 = () => setPagination({
      startFromId: undefined,
      order: OrderEnum.next
    });
    $[8] = setPagination;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== abort || $[11] !== conditions || $[12] !== filter || $[13] !== filterFields || $[14] !== filtersReady || $[15] !== setConditions || $[16] !== setLimit || $[17] !== t3) {
    t4 = {
      abort,
      filterFields,
      filtersReady,
      setLimit,
      setConditions,
      conditions,
      filter,
      onFilterChange: t3,
      delay: 1
    };
    $[10] = abort;
    $[11] = conditions;
    $[12] = filter;
    $[13] = filterFields;
    $[14] = filtersReady;
    $[15] = setConditions;
    $[16] = setLimit;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  useApplyFilterWithConditions(t4);
  let t5;
  if ($[19] !== conditions || $[20] !== removedContacts) {
    t5 = {
      listing: removedContacts,
      filter: conditions
    };
    $[19] = conditions;
    $[20] = removedContacts;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const {
    renderSelectButton,
    getListingSelect,
    renderSelectAllButton
  } = useListingSelect(t5);
  let t6;
  if ($[22] !== getListingSelect) {
    t6 = getListingSelect();
    $[22] = getListingSelect;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  const {
    selectedAll,
    selectedIds,
    exceptionIds
  } = t6;
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = Object.values(ContactFilterRemovedReasonTypeEnum);
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t) {
    t8 = t7.map(el => ({
      id: el,
      caption: t(ContactFilterRemovedReasonLocoKeys[el])
    }));
    $[25] = t;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const ContactRemovedTypeDataForRootAdmin = t8;
  let t9;
  if ($[27] !== ContactRemovedTypeDataForRootAdmin) {
    t9 = ContactRemovedTypeDataForRootAdmin.filter(_temp);
    $[27] = ContactRemovedTypeDataForRootAdmin;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  const ContactRemovedTypeDataForUser = t9;
  let t10;
  if ($[29] !== contactsBulkRestore || $[30] !== revalidateModules || $[31] !== t) {
    t10 = async data => {
      ;
      try {
        await contactsBulkRestore(data);
        await revalidateModules([RequestModuleEnum.Contacts], true);
        toast.success(t("dashboard.contacts_bin.toast_contact_restored"));
      } catch (t11) {
        const e = t11;
        if (e instanceof UnprocessableContentError) {
          e.errors.violations?.forEach(_temp2);
        }
      }
    };
    $[29] = contactsBulkRestore;
    $[30] = revalidateModules;
    $[31] = t;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  const onContactsBulkRestore = t10;
  let t11;
  let t12;
  if ($[33] !== conditions || $[34] !== exceptionIds || $[35] !== selectedAll || $[36] !== selectedIds) {
    t11 = () => {
      setFilterData({
        contactIds: selectedAll ? Array.from(exceptionIds) : Array.from(selectedIds),
        type: selectedAll ? "all-filtered-contacts" : "only-selected-contacts",
        conditions
      });
    };
    t12 = [selectedAll, selectedIds, conditions, exceptionIds];
    $[33] = conditions;
    $[34] = exceptionIds;
    $[35] = selectedAll;
    $[36] = selectedIds;
    $[37] = t11;
    $[38] = t12;
  } else {
    t11 = $[37];
    t12 = $[38];
  }
  useEffect(t11, t12);
  const t13 = `flex ${removedContacts && "gap-3"}`;
  let t14;
  if ($[39] !== removedContacts || $[40] !== renderSelectAllButton) {
    t14 = removedContacts && removedContacts.items.length !== 0 && renderSelectAllButton();
    $[39] = removedContacts;
    $[40] = renderSelectAllButton;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t14) {
    t15 = <div className="hidden items-center lg:flex">{t14}</div>;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t) {
    t16 = t("dashboard.contacts_bin.removal_date");
    $[44] = t;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t) {
    t17 = t("dashboard.contacts_bin.removal_date");
    $[46] = t;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t16 || $[49] !== t17) {
    t18 = <Tooltip wrapperClassName="w-full" label={t16} mode="overflow">{t17}</Tooltip>;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t13 || $[52] !== t15 || $[53] !== t18) {
    t19 = <div className={t13}>{t15}{t18}</div>;
    $[51] = t13;
    $[52] = t15;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== renderSelectButton || $[56] !== user?.dateFormat || $[57] !== user?.timeFormat || $[58] !== user?.timezone) {
    t20 = contact => <div className="flex gap-3"><div className="flex items-center">{renderSelectButton(contact)}</div><span>{dateTimeFormat(contact.removedAt, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></div>;
    $[55] = renderSelectButton;
    $[56] = user?.dateFormat;
    $[57] = user?.timeFormat;
    $[58] = user?.timezone;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== t19 || $[61] !== t20) {
    t21 = {
      key: "registeredAt",
      header: t19,
      onRender: t20,
      widthPercent: 20
    };
    $[60] = t19;
    $[61] = t20;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] !== t) {
    t22 = t("global.email_address");
    $[63] = t;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== t22) {
    t23 = {
      key: "email",
      header: t22,
      widthPercent: 35,
      onRender: _temp3
    };
    $[65] = t22;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  let t24;
  if ($[67] !== t) {
    t24 = t("dashboard.contacts_bin.removed_reason_type");
    $[67] = t;
    $[68] = t24;
  } else {
    t24 = $[68];
  }
  let t25;
  if ($[69] !== t) {
    t25 = contact_1 => contact_1.removedReasonType && <span>{t(ContactFilterRemovedReasonLocoKeys[contact_1.removedReasonType])}</span>;
    $[69] = t;
    $[70] = t25;
  } else {
    t25 = $[70];
  }
  let t26;
  if ($[71] !== t24 || $[72] !== t25) {
    t26 = {
      key: "removedReasonType",
      header: t24,
      widthPercent: 25,
      onRender: t25
    };
    $[71] = t24;
    $[72] = t25;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  let t27;
  if ($[74] !== t) {
    t27 = t("dashboard.contacts_bin.expiration_date");
    $[74] = t;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  let t28;
  if ($[76] !== t) {
    t28 = t("dashboard.contacts_bin.expiration_date");
    $[76] = t;
    $[77] = t28;
  } else {
    t28 = $[77];
  }
  let t29;
  if ($[78] !== t27 || $[79] !== t28) {
    t29 = <Tooltip wrapperClassName="truncate" mode="overflow" label={t27}>{t28}</Tooltip>;
    $[78] = t27;
    $[79] = t28;
    $[80] = t29;
  } else {
    t29 = $[80];
  }
  let t30;
  if ($[81] !== t) {
    t30 = t("dashboard.contacts_bin.hint_expiration_at");
    $[81] = t;
    $[82] = t30;
  } else {
    t30 = $[82];
  }
  let t31;
  if ($[83] !== t30) {
    t31 = <Hint className="truncate pr-3" label={t30} />;
    $[83] = t30;
    $[84] = t31;
  } else {
    t31 = $[84];
  }
  let t32;
  if ($[85] !== t29 || $[86] !== t31) {
    t32 = <div className="flex items-center gap-1">{t29}{t31}</div>;
    $[85] = t29;
    $[86] = t31;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t || $[89] !== user?.dateFormat || $[90] !== user?.timeFormat || $[91] !== user?.timezone) {
    t33 = contact_2 => <span>{contact_2.expirationAt ? dateTimeFormat(contact_2.expirationAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      }) : t("dashboard.contacts_bin.not_applicable")}</span>;
    $[88] = t;
    $[89] = user?.dateFormat;
    $[90] = user?.timeFormat;
    $[91] = user?.timezone;
    $[92] = t33;
  } else {
    t33 = $[92];
  }
  let t34;
  if ($[93] !== t32 || $[94] !== t33) {
    t34 = {
      key: "expirationDate",
      header: t32,
      widthPercent: 20,
      onRender: t33
    };
    $[93] = t32;
    $[94] = t33;
    $[95] = t34;
  } else {
    t34 = $[95];
  }
  let t35;
  if ($[96] !== t21 || $[97] !== t23 || $[98] !== t26 || $[99] !== t34) {
    t35 = [t21, t23, t26, t34];
    $[96] = t21;
    $[97] = t23;
    $[98] = t26;
    $[99] = t34;
    $[100] = t35;
  } else {
    t35 = $[100];
  }
  const columns = t35;
  let t36;
  if ($[101] !== t) {
    t36 = getBreadCrumbsData(t);
    $[101] = t;
    $[102] = t36;
  } else {
    t36 = $[102];
  }
  let t37;
  if ($[103] !== t36) {
    t37 = <BreadcrumbsDashboard data={t36} />;
    $[103] = t36;
    $[104] = t37;
  } else {
    t37 = $[104];
  }
  let t38;
  if ($[105] !== filterData || $[106] !== onContactsBulkRestore) {
    t38 = () => onContactsBulkRestore(filterData);
    $[105] = filterData;
    $[106] = onContactsBulkRestore;
    $[107] = t38;
  } else {
    t38 = $[107];
  }
  let t39;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <ArrowTurnDownLeftIcon />;
    $[108] = t39;
  } else {
    t39 = $[108];
  }
  let t40;
  if ($[109] !== t) {
    t40 = t("dashboard.contacts_bin.restore");
    $[109] = t;
    $[110] = t40;
  } else {
    t40 = $[110];
  }
  let t41;
  if ($[111] !== t40) {
    t41 = <span className="hidden lg:flex">{t40}</span>;
    $[111] = t40;
    $[112] = t41;
  } else {
    t41 = $[112];
  }
  let t42;
  if ($[113] !== isFetching || $[114] !== t38 || $[115] !== t41) {
    t42 = <PrimaryButton isFetching={isFetching} onClick={t38}>{t39}{t41}</PrimaryButton>;
    $[113] = isFetching;
    $[114] = t38;
    $[115] = t41;
    $[116] = t42;
  } else {
    t42 = $[116];
  }
  let t43;
  if ($[117] !== limit || $[118] !== setLimit) {
    t43 = {
      limit,
      setLimit
    };
    $[117] = limit;
    $[118] = setLimit;
    $[119] = t43;
  } else {
    t43 = $[119];
  }
  let t44;
  if ($[120] !== pagination || $[121] !== setPagination) {
    t44 = {
      pagination,
      setPagination
    };
    $[120] = pagination;
    $[121] = setPagination;
    $[122] = t44;
  } else {
    t44 = $[122];
  }
  let t45;
  if ($[123] !== filter || $[124] !== setFilter) {
    t45 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[123] = filter;
    $[124] = setFilter;
    $[125] = t45;
  } else {
    t45 = $[125];
  }
  let t46;
  if ($[126] !== t) {
    t46 = {
      field: ContactSlugEnum.Email,
      onRender: (value, onChange) => {
        const email = value[0] as ContactFilterTextInterface;
        return <FormInputSearch label={<span className="font-inter text-text-primary text-sm font-bold">{t("global.email")}</span>} key="email-filter" type="email" value={email.searchValue} onClear={() => onChange([{
          compareOperation: email.compareOperation,
          searchValue: ""
        }])} onChange={e_0 => onChange([{
          compareOperation: email.compareOperation,
          searchValue: e_0.target.value
        }])} placeholder={t("global.email")} />;
      }
    };
    $[126] = t;
    $[127] = t46;
  } else {
    t46 = $[127];
  }
  let t47;
  if ($[128] !== intlLocale || $[129] !== t || $[130] !== user?.createdAt || $[131] !== user?.timezone) {
    t47 = {
      field: ContactSearchFieldEnum.removed_at,
      onRender: (value_0, onChange_0) => {
        const removedAt = value_0[0] as ContactFilterDateInterface;
        return <div key="removed_at-filter" className="flex flex-col gap-1"><span className="font-inter text-text-primary text-sm font-bold">{t("dashboard.contacts_bin.removed_at")}</span><DatePicker maxDate={getToday(user?.timezone)} minDate={getDate(user?.createdAt, user?.timezone)} value={removedAt.searchValue} onChange={date => onChange_0([{
            compareOperation: removedAt.compareOperation,
            searchValue: date
          }])} timezone={user?.timezone} intlLocale={intlLocale} createdAt={user?.createdAt} /></div>;
      }
    };
    $[128] = intlLocale;
    $[129] = t;
    $[130] = user?.createdAt;
    $[131] = user?.timezone;
    $[132] = t47;
  } else {
    t47 = $[132];
  }
  let t48;
  if ($[133] !== ContactRemovedTypeDataForRootAdmin || $[134] !== ContactRemovedTypeDataForUser || $[135] !== isRootAdmin || $[136] !== t) {
    t48 = {
      field: ContactSearchFieldEnum.removed_reason_type,
      onRender: (value_1, onChange_1) => {
        const contactRemovedReasonType = value_1[0] as ContactFilterRemovedReasonInterface;
        return <FormSelect key="removed_reason_type-filter" label={<span className="font-inter text-text-primary text-sm font-bold">{t("dashboard.contacts_bin.removed_reason_type")}</span>} data={isRootAdmin ? ContactRemovedTypeDataForRootAdmin : ContactRemovedTypeDataForUser} value={contactRemovedReasonType.searchValue} onChange={reasonType => onChange_1([{
          searchValue: reasonType
        }])} />;
      }
    };
    $[133] = ContactRemovedTypeDataForRootAdmin;
    $[134] = ContactRemovedTypeDataForUser;
    $[135] = isRootAdmin;
    $[136] = t;
    $[137] = t48;
  } else {
    t48 = $[137];
  }
  let t49;
  if ($[138] !== t46 || $[139] !== t47 || $[140] !== t48) {
    t49 = [t46, t47, t48];
    $[138] = t46;
    $[139] = t47;
    $[140] = t48;
    $[141] = t49;
  } else {
    t49 = $[141];
  }
  let t50;
  if ($[142] !== t43 || $[143] !== t44 || $[144] !== t45 || $[145] !== t49) {
    t50 = {
      limiter: t43,
      paginator: t44,
      filterer: t45,
      filterable: t49
    };
    $[142] = t43;
    $[143] = t44;
    $[144] = t45;
    $[145] = t49;
    $[146] = t50;
  } else {
    t50 = $[146];
  }
  let t51;
  if ($[147] !== removedContacts || $[148] !== renderSelectAllButton || $[149] !== t) {
    t51 = removedContacts && removedContacts.items.length !== 0 && <div className="bg-brand-primary-subtle flex items-center gap-3 rounded-t-lg px-6 py-4 lg:hidden">{renderSelectAllButton()}<span>{t("global.select_all")}</span></div>;
    $[147] = removedContacts;
    $[148] = renderSelectAllButton;
    $[149] = t;
    $[150] = t51;
  } else {
    t51 = $[150];
  }
  let t52;
  if ($[151] !== limit || $[152] !== setLimit) {
    t52 = {
      limit,
      setLimit
    };
    $[151] = limit;
    $[152] = setLimit;
    $[153] = t52;
  } else {
    t52 = $[153];
  }
  let t53;
  if ($[154] !== pagination || $[155] !== setPagination) {
    t53 = {
      pagination,
      setPagination
    };
    $[154] = pagination;
    $[155] = setPagination;
    $[156] = t53;
  } else {
    t53 = $[156];
  }
  let t54;
  if ($[157] !== columns || $[158] !== removedContacts || $[159] !== t52 || $[160] !== t53) {
    t54 = <Table data={removedContacts} columns={columns} limiter={t52} paginator={t53} />;
    $[157] = columns;
    $[158] = removedContacts;
    $[159] = t52;
    $[160] = t53;
    $[161] = t54;
  } else {
    t54 = $[161];
  }
  let t55;
  if ($[162] !== t51 || $[163] !== t54) {
    t55 = <div className="w-full">{t51}{t54}</div>;
    $[162] = t51;
    $[163] = t54;
    $[164] = t55;
  } else {
    t55 = $[164];
  }
  let t56;
  if ($[165] !== removedContacts || $[166] !== t37 || $[167] !== t42 || $[168] !== t50 || $[169] !== t55) {
    t56 = <ListingLayout data={removedContacts} counter={false} type="side" title={t37} customHeaderElement={t42} filterData={t50}>{t55}</ListingLayout>;
    $[165] = removedContacts;
    $[166] = t37;
    $[167] = t42;
    $[168] = t50;
    $[169] = t55;
    $[170] = t56;
  } else {
    t56 = $[170];
  }
  return t56;
};
export const getServerSideProps = getBaseServerSideProps(ContactsLoco, 'header.top_menu.contacts');
export default Contacts;
function _temp(item) {
  return item.id !== ContactFilterRemovedReasonTypeEnum.automatically_from_sio_students;
}
function _temp2(violation) {
  toast.error(violation.message);
}
function _temp3(contact_0) {
  return <div className="flex w-full items-center gap-2 overflow-hidden"><div className="h-[48px] w-[48px] min-w-[48px] rounded-full"><img className="rounded-full" src={contact_0.avatar} alt="avatar" /></div><div className="flex w-fit flex-col justify-center overflow-hidden">{contact_0.email}</div></div>;
}